const styles = theme => ({
  dialog: {
    maxWidth: 600
  },
  checkCircle: {
    color: '#ED0F4B'
  }
})

export default styles;